import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, interval, switchMap, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';

const apiURLs = {
  root: environment.restApiUrl,
  notifications: '/client/notifications/',
}

@Injectable({
  providedIn: 'root'
})
export class ApiNotificationsService {

  private stopPolling = new Subject<void>();

  constructor(private http: HttpClient) { }

  getNotifications(): Observable<any> {
    return this.http.get<any>(apiURLs.root + apiURLs.notifications);
  }

  markNotificationsAsRead(ntype: number): Observable<any> {
    return this.http.post(apiURLs.root + apiURLs.notifications, {ntype: ntype});
  }

  startPolling(intervalTime: number): Observable<any> {
    return interval(intervalTime).pipe(
      switchMap(() => this.getNotifications()),
      takeUntil(this.stopPolling)
    );
  }

  stopPollingNotifications() {
    this.stopPolling.next();
  }

  ngOnDestroy() {
    this.stopPolling.next();
    this.stopPolling.complete();
  }
  
}
